import type { SxProps, Theme } from '@mui/material/styles';

type DealerTransferHistoryStyleMap = {
    headerRow: SxProps<Theme>
    headerCell: SxProps<Theme>
    clickableRow: SxProps<Theme>
};

export const dealerTransferHistoryStyles: DealerTransferHistoryStyleMap = {
    headerRow: { bgcolor: 'grey.50' },
    headerCell: { fontWeight: 600 },
    clickableRow: { cursor: 'pointer' },
};
